import posthog from "posthog-js";

const KEY = process.env.REACT_APP_POSTHOG_KEY;
const HOST = process.env.REACT_APP_POSTHOG_HOST;
const CONSENT_KEY = "binshare_cookie_consent";
export const OPEN_CONSENT_EVENT = "binshare:open-cookie-settings";

let inited = false;

export function getConsent() {
  try {
    return window.localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

// Strip IP / GeoIP enrichment client-side; also enable "Discard client IP data" in PostHog.
function anonymise(event) {
  if (!event) return event;
  event.properties = { ...event.properties, $ip: null, $geoip_disable: true };
  return event;
}

export function initAnalytics() {
  if (inited || !KEY || getConsent() !== "accepted") return;
  if (navigator.globalPrivacyControl === true) return;
  posthog.init(KEY, {
    api_host: HOST,
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: false,
    capture_dead_clicks: false,
    capture_exceptions: false,
    capture_performance: false,
    rageclick: false,
    enable_heatmaps: false,
    disable_session_recording: true,
    disable_surveys: true,
    mask_all_text: true,
    mask_all_element_attributes: true,
    person_profiles: "identified_only",
    before_send: anonymise,
  });
  inited = true;
}

export function setConsent(value) {
  try {
    window.localStorage.setItem(CONSENT_KEY, value);
  } catch {
    // Storage blocked: choice applies to this page view only.
  }
  if (value === "accepted") {
    if (inited) posthog.opt_in_capturing();
    initAnalytics();
    trackPageview();
  } else if (inited) {
    posthog.opt_out_capturing();
  }
}

export function trackPageview() {
  if (!inited || getConsent() !== "accepted") return;
  posthog.capture("$pageview");
}

export function isAnalyticsActive() {
  return inited && getConsent() === "accepted";
}
